import React, { useState, useEffect} from 'react';

export const CalendarioAsistencia = ({m, a, asistencias}) => {
    let [fecha, setFecha] = useState(new Date(a,m,1));
    let [fechas,setFechas] = useState([]);
    let [semanas,setSemanas] = useState([0,1,2,3,4,5]);
    let [dias,setDias] = useState([0,1,2,3,4,5,6]);

    useEffect(() => {
        cargar();
    }, [fecha]);
    function cargar(){
        let dias = 42;
        let f = new Date(fecha.getFullYear(), fecha.getMonth(), 1);
        while (f.getDay() > 0){
            f.setDate(f.getDate() - 1);
        }
        for (let k = 0; k < dias; k++){
            fechas[k] = new Date(f.getFullYear(), f.getMonth(), f.getDate());;
            f.setDate(f.getDate() + 1);
        }
    }
    function nombreMes(){
        let meses=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
        return meses[fecha.getMonth()];
    }

    return (
        <div style={{margin:5}}>
            <table>
                <thead>
                    <tr>
                        <th colSpan={7} className="dia diaMes">{nombreMes()}</th>
                    </tr>
                    <tr>
                        <th className="dia diaTit">D</th>
                        <th className="dia diaTit">L</th>
                        <th className="dia diaTit">M</th>
                        <th className="dia diaTit">M</th>
                        <th className="dia diaTit">J</th>
                        <th className="dia diaTit">V</th>
                        <th className="dia diaTit">S</th>
                    </tr>
                </thead>
                <tbody>
                    {semanas.map((o,s) => 
                    <tr key={s}>
                        {dias.map((o,d) => {
                            let i = s * 7 + d;
                            let dia = "";
                            let clase ="dia";
                            let asistio = "";
                            if(fechas[i] != null){
                                let fec = fechas[i].yyyymmdd('-');
                                for(let i = 0; i < asistencias.length; i++)
                                    if(asistencias[i].fecha == fec)
                                        asistio = asistencias[i].asistio;
                                dia = fechas[i].getDate();
                                if(fechas[i].getMonth() !== fecha.getMonth()){
                                    clase ="dia diaGris";
                                    asistio = "";
                                }
                                if(asistio === "S")
                                    clase ="dia diaVerde";
                                if(asistio === "R")
                                    clase ="dia diaAmarillo";
                                if(asistio === "J")
                                    clase ="dia diaNaranja";
                                if(asistio === "N")
                                    clase ="dia diaRojo";
                            }
                            return <td className={clase}>{dia}</td>
                        })}
                    </tr>)}
                </tbody>
            </table>
        </div>
    )
}

export const CalendariosAsistencia = ({asistencias}) => {
    let [meses, setMeses] = useState([]);
    useEffect(() => {
        procesar();
        //console.log("asistencias",asistencias);
    }, [asistencias]);

    function procesar(){
        meses = [];
        let a = 0;
        let m = 0;
        let mm = -2;
        for(let i = 0; i < asistencias.length; i++){
            a = Number(asistencias[i].fecha.substring(0,4));
            m = Number(asistencias[i].fecha.substring(5,7)) - 1;
            //console.log("A",a);            
            //console.log("M",m);            
            if(m != mm){
                mm = m;
                meses.push({a, m });
            }
        }
        setMeses(meses);
        console.log("meses",meses);
    }
    return (
        <div>
            {meses.map((d,i) => <CalendarioAsistencia m={d.m} a={d.a} asistencias={asistencias}/>)}
        </div>
    )
}